import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/EmployerUsersTable/component'

export const EmployerUsersTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
